export const cartAccum = (cart) => {
  let accum = cart
    .map(({ price, qty }) => price * qty)
    .reduce((sum, i) => sum + i, 0);
  return accum;
};
